module.exports = __webpack_public_path__ + "img/palacio_02.b9a9fb87.jpg";